import { dfsCollectGraphPaths } from "utils/math/dfsCollectGraphPaths";
import type { ScaledRoute } from "../../SmartSurveyorForRudolfFritz/utils/types";
import type { CircuitPathsState } from "../../ReviewPage/hooks/useCircuitCablePaths/types";

export interface BuildCircuitPathsStateArgs {
  route: ScaledRoute;
  rgb?: [number, number, number];
}

export type BuildCircuitPathsStateResult = CircuitPathsState | null;

export type BuildCircuitPathsState = (
  args: BuildCircuitPathsStateArgs,
) => BuildCircuitPathsStateResult;

export const buildCircuitPathsState: BuildCircuitPathsState = ({
  route,
  rgb,
}) => {
  const nodes = route.nodes ?? [];
  const edges = route.edges ?? [];

  if (nodes.length < 2 || edges.length === 0) return null;

  const routeTotalMeters = Number(route.meters) || 0;
  const allPaths = dfsCollectGraphPaths({ nodes, edges });
  const coordinateExtents = route.coordinateExtents;

  const paths = allPaths.flatMap((waypoints, index) => {
    const startWaypoint = waypoints[0];
    return [
      {
        routeId: route.id,
        coordinateExtents,
        destinationId: `${route.id}-${index}`,
        destinationName: route.name,
        waypoints,
        trayMeters: routeTotalMeters,
        totalMeters: routeTotalMeters,
        reachable: true,
        rgb,
      },
      {
        routeId: route.id,
        coordinateExtents,
        destinationId: `${route.id}-${index}-start`,
        destinationName: `${route.name}-start`,
        waypoints: [startWaypoint],
        trayMeters: 0,
        totalMeters: 0,
        reachable: true,
        rgb,
      },
    ];
  });

  return {
    paths,
    distributionBoardPosition: null,
    totalCableLength: routeTotalMeters,
  };
};
